import { render, staticRenderFns } from "./detail_tcsj.vue?vue&type=template&id=de9030ec&scoped=true&"
import script from "./detail_tcsj.vue?vue&type=script&lang=js&"
export * from "./detail_tcsj.vue?vue&type=script&lang=js&"
import style0 from "./detail_tcsj.vue?vue&type=style&index=0&id=de9030ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9030ec",
  null
  
)

export default component.exports